<template>
  <v-dialog
    v-model="dialogModel"
    :persistent="persistent"
    :width="width"
    @keydown.enter.stop="handleOk"
  >
    <v-card>
      <v-card-title
        v-if="showTitle"
        class="text-h6 font-weight-bold d-flex align-center justify-center gap-2"
      >
        {{ title || resolved.title }}
      </v-card-title>
      <v-card-text
        :class="showTitle ? 'py-3' : 'pt-6 pb-3'"
        class="text-center"
        style="white-space: pre-wrap"
      >
        {{ message }}
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          variant="outlined"
          :color="okColor || resolved.color"
          class="mb-3"
          :style="
            props.type === 'error'
              ? 'background: #FAE6E6'
              : props.type === 'info'
                ? 'background: #E6F6FF'
                : ''
          "
          @click="handleOk"
        >
          {{ okText || "OK" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: "" },
  message: { type: String, default: "" },
  type: {
    type: String as () => "error" | "info",
    default: "error",
  },
  okText: { type: String, default: "" },
  okColor: { type: String, default: "" },
  width: { type: [Number, String], default: 450 },
  persistent: { type: Boolean, default: true },
  showIcon: { type: Boolean, default: true },
  showTitle: { type: Boolean, default: true },
});

const emit = defineEmits(["update:modelValue", "ok"]);

const dialogModel = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const resolved = computed(() => {
  const map = {
    error: { color: "red-lighten-2", icon: "mdi-alert-circle", title: "エラー" },
    info: { color: "cyan-lighten-2", icon: "mdi-information", title: "お知らせ" },
  };
  return map[props.type] || map.error;
});

const handleOk = () => {
  emit("ok");
  emit("update:modelValue", false);
};
</script>
